import styled from 'styled-components';

type Props = {
  onClick?: () => void;
};

const AddButton = ({ onClick }: Props) => {
  return (
    <Button onClick={onClick} type='button'>
      <div>
        <IconAdd />
      </div>
      <span>Add Service</span>
    </Button>
  );
};

export default AddButton;

const Button = styled.button`
  display: flex;
  height: 56px;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px dashed #2d6772;
  background: #fff;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  transition: all 0.3s ease;
  user-select: none;
  span {
    color: #2d6772;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

const IconAdd = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.2998 4.5C12.714 4.5 13.0498 4.83579 13.0498 5.25V18.75C13.0498 19.1642 12.714 19.5 12.2998 19.5C11.8856 19.5 11.5498 19.1642 11.5498 18.75V5.25C11.5498 4.83579 11.8856 4.5 12.2998 4.5Z'
      fill='#2D6772'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.7998 12C4.7998 11.5858 5.13559 11.25 5.5498 11.25H19.0498C19.464 11.25 19.7998 11.5858 19.7998 12C19.7998 12.4142 19.464 12.75 19.0498 12.75H5.5498C5.13559 12.75 4.7998 12.4142 4.7998 12Z'
      fill='#2D6772'
    />
    <path
      d='M12.2998 4C12.9902 4 13.5498 4.55964 13.5498 5.25V10.75H19.0498C19.7402 10.75 20.2998 11.3096 20.2998 12C20.2998 12.6904 19.7402 13.25 19.0498 13.25H13.5498V18.75C13.5498 19.4404 12.9902 20 12.2998 20C11.6094 20 11.0498 19.4404 11.0498 18.75V13.25H5.5498C4.85945 13.25 4.2998 12.6904 4.2998 12C4.2998 11.3096 4.85945 10.75 5.5498 10.75H11.0498V5.25C11.0498 4.55964 11.6094 4 12.2998 4ZM12.0498 13.25V18.75C12.0498 18.8881 12.1617 19 12.2998 19C12.4379 19 12.5498 18.8881 12.5498 18.75V13.25H12.0498ZM13.5498 12.25H19.0498C19.1879 12.25 19.2998 12.1381 19.2998 12C19.2998 11.8619 19.1879 11.75 19.0498 11.75H13.5498V12.25ZM12.0498 12.25H12.5498V11.75H12.0498V12.25ZM5.5498 11.75C5.41173 11.75 5.2998 11.8619 5.2998 12C5.2998 12.1381 5.41173 12.25 5.5498 12.25H11.0498V11.75H5.5498ZM12.2998 5C12.1617 5 12.0498 5.11193 12.0498 5.25V10.75H12.5498V5.25C12.5498 5.11193 12.4379 5 12.2998 5Z'
      fill='#2D6772'
    />
  </svg>
);
